var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13807 8.19534C7.39842 8.45569 7.39842 8.8778 7.13807 9.13815L5.60948 10.6667L7.13807 12.1953C7.39842 12.4557 7.39842 12.8778 7.13807 13.1382C6.87772 13.3985 6.45561 13.3985 6.19526 13.1382L4.19526 11.1382C3.93491 10.8778 3.93491 10.4557 4.19526 10.1953L6.19526 8.19534C6.45561 7.93499 6.87772 7.93499 7.13807 8.19534Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3333 6.66675C15.7015 6.66675 16 6.96522 16 7.33341V10.6667C16 11.0349 15.7015 11.3334 15.3333 11.3334H4.66667C4.29848 11.3334 4 11.0349 4 10.6667C4 10.2986 4.29848 10.0001 4.66667 10.0001H14.6667V7.33341C14.6667 6.96522 14.9651 6.66675 15.3333 6.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardShortcut);
export default __webpack_public_path__ + "static/media/keyboardShortcut.737efa748a004047098686c9a0a35887.svg";
export { ForwardRef as ReactComponent };